import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as queryString from 'query-string';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { List2Res, Metrics, MetricsCreateRequest, MetricsUpdateRequest, Pageable } from 'src/app/shared';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MetricService {
  public loading$ = new Subject<boolean>();

  constructor(
    private http: HttpClient,
  ) { }

  search(pageable?: Pageable): Observable<List2Res<Metrics>> {
    const params = queryString.stringify({ ...pageable });

    this.loading$.next(true);
    return this.http.get<List2Res<Metrics>>(`${environment.apiUrl}/metrics?${params}`).pipe(
      finalize(() => this.loading$.next(false)),
    );
  }

  create(payload: MetricsCreateRequest) {
    return this.http.post<Metrics>(`${environment.apiUrl}/metrics`, payload);
  }

  update(id: number, payload: MetricsUpdateRequest) {
    return this.http.put<Metrics>(`${environment.apiUrl}/metrics/${id}`, payload);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/metrics/${id}`);
  }
}
